import { Component, useCallback, useRef } from "react";
import { useClassificationParameterBoundaries } from "./useClassificationParameterBoundaries";

export const useSizeRanges = () => {
  const [{ to, from, min, max, isReversed }, { setTo, setFrom, updateFrom, updateTo, recalc, reverse }] =
    useClassificationParameterBoundaries();

  const fromInput = useRef(null);
  const toInput = useRef(null);

  const changeFrom = useCallback(
    (value: number | null) => {
      const isFocused = getFocusedState(fromInput.current);
      const ableUpdateTo = !isFocused && value !== null && (isReversed ? value < to : value > to);

      ableUpdateTo && setTo(value);
      setFrom(value);
    },
    [to, setTo, setFrom, fromInput, isReversed],
  );

  const changeTo = useCallback(
    (value: number | null) => {
      const isFocused = getFocusedState(toInput.current);
      const ableUpdateFrom = !isFocused && value !== null && (isReversed ? value > from : value < from);

      ableUpdateFrom && setFrom(value);
      setTo(value);
    },
    [from, setTo, setFrom, toInput, isReversed],
  );

  return {
    updateFrom,
    changeFrom,
    from,
    fromInput,
    updateTo,
    changeTo,
    to,
    toInput,
    max,
    min,
    isReversed,
    recalc,
    reverse,
  };
};

function getFocusedState(ref: Component<unknown, { focused: boolean }> | null): boolean {
  return ref && ref.state && ref.state.focused;
}
